import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=7cace2e1&scoped=true"
import script from "./AddDiscount.vue?vue&type=script&lang=js"
export * from "./AddDiscount.vue?vue&type=script&lang=js"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=7cace2e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cace2e1",
  null
  
)

export default component.exports